// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".appearance-enter-active[data-v-91f4f562],.appearance-leave-active[data-v-91f4f562]{transition:.4s}.appearance-enter[data-v-91f4f562],.appearance-leave-to[data-v-91f4f562]{transform:translateX(-100%);opacity:0}.menu-background[data-v-91f4f562]{position:fixed;width:100%;height:100%;z-index:97;top:0;display:none}@media(max-width: 900px){.menu-background[data-v-91f4f562]{display:block}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
